import React from "react";
import PopupWrapper from "../../../common/PopupWrapper";
import UprTargetingsView from "./UprTargetingsView";

class UprTargetingPopover extends React.PureComponent {
  render() {
    const {
      targetingSection = {},
      triggerElement,
      units,
      virtualPlacements,
      placements = [],
      networkId,
      id,
      name,
      place = "bottom",
    } = this.props;

    return (
      <PopupWrapper
        place={place}
        triggerType="click"
        hideArrow={false}
        triggerElement={triggerElement}
        onOpen={this.props.onOpen}
        onClose={this.props.onClose}
        nested={true}
        popupElement={
          <div
            className="shadow border p-4"
            style={{ width: "600px", maxHeight: "600px", overflow: "auto" }}
          >
            <UprTargetingsView
              id={id}
              name={name}
              networkId={networkId}
              targetingSection={targetingSection}
              units={units}
              virtualPlacements={virtualPlacements}
              placements={placements}
            ></UprTargetingsView>
          </div>
        }
      ></PopupWrapper>
    );
  }
}

export default UprTargetingPopover;
